import { formatarDataExtensa, formatarJanela } from '@/helpers/formatacao.helpers';
import type { Manutencao } from '@/types/status.types';

type ManutencoesProgramadasProps = {
  manutencoes: Manutencao[];
};

export const ManutencoesProgramadas = ({ manutencoes }: ManutencoesProgramadasProps) => {
  if (manutencoes.length === 0) {
    return null;
  }

  return (
    <section className="cartao-status" aria-labelledby="titulo-manutencoes">
      <h2 id="titulo-manutencoes" className="m-0 text-[15px] font-semibold tracking-[-0.01em]">
        Manutenção programada
      </h2>

      <ul className="list-none p-0">
        {manutencoes.map((manutencao) => (
          <li
            key={manutencao.id}
            className="mt-2.5 flex flex-wrap gap-x-[18px] gap-y-2 border-t border-border pt-3.5 pb-0.5"
          >
            <div className="w-[132px] flex-none">
              <div className="text-[14px] font-semibold">
                <time dateTime={manutencao.inicio}>{formatarDataExtensa(manutencao.inicio)}</time>
              </div>
              <div className="mt-0.5 text-[12px] text-muted-foreground">
                {formatarJanela(manutencao.inicio, manutencao.fim)}
              </div>
            </div>
            <div className="min-w-[220px] flex-1">
              <div className="text-[14px] font-medium">{manutencao.titulo}</div>
              {manutencao.descricao && (
                <p className="mt-[5px] mb-0 text-[13px] leading-[1.55] text-pretty text-muted-foreground">
                  {manutencao.descricao}
                </p>
              )}
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
};
